import { render, staticRenderFns } from "./AddGroupNumber2025.vue?vue&type=template&id=e44b570a&scoped=true"
import script from "./AddGroupNumber2025.vue?vue&type=script&lang=js"
export * from "./AddGroupNumber2025.vue?vue&type=script&lang=js"
import style0 from "./AddGroupNumber2025.vue?vue&type=style&index=0&id=e44b570a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44b570a",
  null
  
)

export default component.exports